import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";
import LargeItemStatus from "../../../../../../common/components/large_item_status";


type Props = {
  onActionEditar: (IdAuditoria: number | null) => void,
  onActionDeletar: (IdAuditoria: number | null, openState: boolean) => void,
  onActionCopiar: (IdAuditoria: number | null, openState: boolean) => void,
  onActionExportar: (IdAuditoria: number) => void,
};

export const GenerateAuditoriaAuditoriasColumns = ({
  onActionEditar,
  onActionDeletar,
  onActionCopiar,
  onActionExportar
}: Props): GridColDef[] => {

  //#region Status
   const computeItemStatusTitle = (status: boolean) => {
    switch (status) {
      case true:
        return "A";
      case false:
        return "E";
      default:
        return "?";
    }
  };
  const computeItemStatusColor = (status: boolean) => {
    switch (status) {
      case true:
        return "green";
      case false:
        return "yellow";
      default:
        return "blue";
    }
  };
  const computeItemStatusDescription = (status: boolean) => {
    switch (status) {
      case true:
        return "Em aberto";
      case false:
        return "Encerrada";
      default:
        return "?";
    }
  };

  //#endregion

  //#region  TipoAuditoria
   const computeItemTipoAuditoriaTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Externa";
      case 0:
        return "Interna";
      default:
        return "?";
    }
  };
  const computeItemTipoAuditoriaColor = (status: number) => {
    switch (status) {
      case 0:
        return "green";
      default:
        return "blue";
    }
  };

  //#endregion

  return [
    {
      field: "EmAberto",
      filterable: false,
      headerName: "Status",
      width: 100, 
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "TipoAuditoria",
      filterable: false,
      headerName: "Auditoria",
      width: 100, 
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <LargeItemStatus
            title={computeItemTipoAuditoriaTitle(params.value)}
            color={computeItemTipoAuditoriaColor(params.value)}
            description=""/>
        </div>
      )
    },
    {
      field: "Evento",
      filterable: false,
      headerName: "Evento",
      flex: 1, 
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "DataElaboracao",
      filterable: false,
      headerName: "Data Elaboração",
      width: 120, 
      sortable: false,
      renderCell: (params) => {
        return (
          <span className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {params.value && dayjs(params.value).format("DD/MM/YYYY")}
          </span>
        );
      },
    },
    {
      field: "DataAuditoria",
      filterable: false,
      headerName: "Data Início",
      width: 100, 
      sortable: false,
      renderCell: (params) => {
        return (
          <span className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {params.value && dayjs(params.value).format("DD/MM/YYYY")}
          </span>
        );
      },
    },
     {
      field: "DataTermino",
      filterable: false,
      headerName: "Data Término",
      width: 100, 
      sortable: false,
       renderCell: (params) => {
          return (
            <span className="w-full h-full flex justify-center items-center text-center text-xs py-2">
              {params.value && dayjs(params.value).format("DD/MM/YYYY")}
            </span>
          );
        },
    },
    {
      field: "Exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      width: 100, 
      valueGetter: (_, row) => {
        return row["IdAuditoria"] as number;
      },
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onActionExportar(value);
                } else {
                  onActionExportar(value);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".2rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
              }}
            >
              Exportar
            </Button>
          </div>
        );
      },
    },
    {
    field: 'IdAuditoria',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    width: 140, // Trocado minWidth por width fixo (140px é perfeito para 3 botões)

    renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-1">
            
            <IconButton onClick={() => onActionEditar(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionCopiar(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopyRounded" size={22} className="dark:text-white text-gray-500" />
            </IconButton>
            
            <IconButton onClick={() => onActionDeletar(params.value, true)} >
              <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
            </IconButton>

          </div>
        );
      }
    },
  ];
}